import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthGate';

const tabs = [
  { to: '/', icon: 'home', label: 'Главная' },
  { to: '/menu', icon: 'restaurant_menu', label: 'Меню' },
  { to: '/orders', icon: 'shopping_bag', label: 'Заказы', badge: '12' },
  { to: '/more', icon: 'more_horiz', label: 'Ещё' },
];

const titles = {
  '/': 'Главная',
  '/menu': 'Меню',
  '/orders': 'Заказы',
  '/more': 'Ещё',
  '/contacts': 'Контакты',
  '/delivery': 'Доставка',
  '/available': 'Доступность',
};

export const Icon = ({ name, className = '' }) => (
  <span className={`material-icons app-icon ${className}`} aria-hidden="true">
    {name}
  </span>
);

const AppShell = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [isTabbarHidden, setIsTabbarHidden] = useState(false);
  const title = titles[location.pathname] || 'SHD Admin';
  const canGoBack = !['/', '/menu', '/orders', '/more'].includes(location.pathname);

  useEffect(() => {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const updateTabbar = () => {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollY;

      if (currentScrollY < 24) {
        setIsTabbarHidden(false);
      } else if (delta > 8) {
        setIsTabbarHidden(true);
      } else if (delta < -8) {
        setIsTabbarHidden(false);
      }

      lastScrollY = currentScrollY;
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateTabbar);
        ticking = true;
      }
    };

    setIsTabbarHidden(false);
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location.pathname]);

  return (
    <div className={`app-shell ${isTabbarHidden ? 'chrome-hidden' : ''}`}>
      <header className="app-topbar">
        {canGoBack ? (
          <button
            type="button"
            className="icon-button"
            onClick={() => navigate(-1)}
            aria-label="Назад"
          >
            <Icon name="chevron_left" />
          </button>
        ) : (
          <button type="button" className="icon-button muted-action" aria-label="Уведомления">
            <Icon name="notifications_none" />
            <span className="dot-badge">1</span>
          </button>
        )}
        <h1>{title}</h1>
        <div className="topbar-actions">
          {location.pathname === '/menu' ? (
            <button type="button" className="round-action" aria-label="Добавить">
              <Icon name="add" />
            </button>
          ) : location.pathname === '/' ? (
            <button type="button" className="icon-button muted-action" onClick={logout} aria-label="Выйти">
              <Icon name="logout" />
            </button>
          ) : (
            <span className="topbar-spacer" aria-hidden="true" />
          )}
        </div>
      </header>

      <main className="app-content">{children}</main>

      <nav
        className={`app-tabbar ${isTabbarHidden ? 'is-hidden' : ''}`}
        aria-label="Основная навигация"
      >
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) => `tab-item ${isActive ? 'active' : ''}`}
            end={tab.to === '/'}
          >
            <span className="tab-icon-wrap">
              <Icon name={tab.icon} />
              {tab.badge ? <span className="tab-badge">{tab.badge}</span> : null}
            </span>
            <span>{tab.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default AppShell;
